import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'

Vue.use(Vuex)

const device_module = {
  namespaced: true,
  state,
  mutations: {
    tx_num_update_charging (state, charging) {
      if (charging) {
        state.tx.num_standby = 0
        state.tx.num_charging = 1
      } else {
        state.tx.num_standby = 1
        state.tx.num_charging = 0
      }
    },
    tx_num_update_error (state, is_error) {
      if (is_error) {
        state.tx.num_error = 1
        state.tx.num_charging = 0
        state.tx.num_standby = 0
      } else {
        state.tx.num_error = 0
        // state.tx.num_charging = 0
        // state.tx.num_standby = 0
      }
    },
    add_charging_history (state, record) {
      state.charging_history.push(record)
    }

  },
  actions: {
    add_charging_history ({ commit, dispatch, state }, record) {
      commit('add_charging_history', record)
    }
  },
  getters: {
    tx_num_standby: (state) => {
      return state.tx.num_total - state.tx.num_charging - state.tx.num_error - state.tx.num_offline
    },
    charging_history: (state) => {
      return state.charging_history
    }
  }
}
const web_auth_module = {
  namespaced: true,
  state: {
    token: localStorage.getItem('access_token') || null
  },
  mutations: {
    retrieveToken (state, token) {
      state.token = token
    },
    destroyToken (state) {
      state.token = null
    }
  },
  getters: {
    loggedIn: (state) => {
      return state.token !== null
    }
  },
  actions: {
    destroyToken (context) {
      if (context.getters.loggedIn) {
        localStorage.removeItem('access_token')
        context.commit('destroyToken')
      }
    },
    retrieveToken (context, credentials) {
      return new Promise((resolve, reject) => {
        if (credentials.username === 'user1@mpsa.com' && credentials.password === 'password1') {
          const response = {
            data: {
              access_token: 'Ep5uc%nqxUlG7YgrDWsET3IcECnmL'
            }
          }
          const token = response.data.access_token
          localStorage.setItem('access_token', token)
          context.commit('retrieveToken', token)
          resolve(response)
        } else {
          const error = {
            response: {
              data: 'Incorrect username/password'
            }
          }
          reject(error)
        }
      })
      // return new Promise((resolve, reject) => {
      //   axios.post('/login', {
      //     username: credentials.username,
      //     password: credentials.password,
      //   })
      //     .then(response => {
      //       const token = response.data.access_token
      //
      //       localStorage.setItem('access_token', token)
      //       context.commit('retrieveToken', token)
      //       resolve(response)
      //       // console.log(response);
      //       // context.commit('addTodo', response.data)
      //     })
      //     .catch(error => {
      //       console.log(error)
      //       reject(error)
      //     })
      //   })
    }
  }

}
export default new Vuex.Store({
  modules: {
    dev: device_module,
    web_auth: web_auth_module
  }
})
